import { popError } from "./Popup";
import { Utils } from "./Utils";

export function initGlobalErrorHandler() : void {
    // Uncaught exceptions (synchronous errors)
    window.onerror = function (message) {
        Utils.logMessage(String(message));
        return false;
    };

    // Unhandled Promise rejections
    window.onunhandledrejection = function (event) {
        const reason = event.reason;
        const error = reason instanceof Error ? reason : new Error(String(reason));
        Utils.logMessage(error.message);
        popError(error.message);
    };
}
